import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateReleaseEarmarkStatusReduxParams } from '~types/feat/approval';

import { EarmarkReleaseRequestStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateProjectStatusModal.module.scss';

const ConfirmUpdateReleaseEarmarkStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateReleaseEarmarkModalIsOpen);
    const tempUpdateReleaseEarmark = useAppSelector(state => state.approval.tempUpdateReleaseEarmark);
    const isLoading = useAppSelector(state => state.approval.loadings.updateReleaseEarmarkStatus);
    const error = useAppSelector(state => state.approval.errors.updateReleaseEarmarkStatus);

    const getStatus = () => {
        switch (tempUpdateReleaseEarmark.status) {
            case (EarmarkReleaseRequestStatusEnum.Approved): return 'Approve';
            case (EarmarkReleaseRequestStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateReleaseEarmarkStatusModalIsOpen(open));
    const updateReleaseEarmarkStatus = (data: TUpdateReleaseEarmarkStatusReduxParams) => dispatch(combinedActions.approvalUpdateReleaseEarmarkStatusAttempt(data));

    const handleSubmitClick = () => {
        updateReleaseEarmarkStatus(tempUpdateReleaseEarmark);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateReleaseEarmarkStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Release Earmark?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateReleaseEarmarkStatusModal;
